// extracted by mini-css-extract-plugin
module.exports = {"background-container":"Background_background-container__2HMBR","background-gif":"Background_background-gif__3uRTA"};